import { Routes } from '@angular/router';

export const routes: Routes = [{
  path: '',
  loadChildren: () => import('./landing/landing-module').then(m => m.LandingModule)
}, {
    path: 'post/:slug',
    loadComponent: () => import('./landing/stories/post/post').then(m => m.Post),
    data: { prerender: true }
  }];
